export const overlayVariants = {
  open: {
    opacity: 1,
    display: 'block',
    transition: {
      duration: 0.1
    }
  },
  closed: {
    transitionEnd: {
      display: 'none',
      opacity: 0
    },
    transition: {
      duration: 0.1
    }
  }
};
export const mainContainerVariants = {
  open: {
    opacity: 1,
    height: 'fit-content',
    display: 'block',
    transition: {
      duration: 0.1
    }
  },
  closed: {
    height: '0%',
    transitionEnd: {
      opacity: 0,
      display: 'none'
    },
    transition: {
      duration: 0.1
    }
  }
};
export const buttonContainerVariants = {
  open: {
    opacity: 1
  },
  closed: {
    transitionEnd: {
      opacity: 0
    },
    transition: {
      duration: 0.1
    }
  }
};
export const menuContainerVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  },
  closed: {
    opacity: 0,
    y: -10,
    transition: {
      duration: 0.2
    }
  }
};
export const menuVariants = {
  open: {
    opacity: 1
  },
  closed: {
    transitionEnd: {
      opacity: 0
    }
  }
};